import { Code } from '@chakra-ui/react';
import React from 'react';

const CodeBlock = props => <Code w="full" whiteSpace="pre-wrap" p={4} {...props} />;

export default CodeBlock;
